import { styled } from '@mui/material';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { ExtendedAdditionalCompensationResponse } from './AdditionalCompensations.types';

export const StyledTableCRUDLayout = styled(
  TableCRUDLayout<ExtendedAdditionalCompensationResponse>
)(({ theme }) => ({
  marginTop: theme.spacing(1)
}));
